import * as angular from 'angular';
import { ManageUsersFabComponent } from './manage-users-fab.component';

export const ManageUsersFabModule = angular
  .module('manageUsersFab', [])
  .component('manageUsersFab', ManageUsersFabComponent).name;
